/* src/app/shared/components/item-length/item-length.component.scss */
/*# sourceMappingURL=item-length.component-PEZ66SRY.css.map */
